import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { hasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import { useMemo } from 'react';

import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';
import { ChargePointSectionComponent } from '@app/feature/statistics/charge-point-section/charge-point-section.component';

import { EnergySectionComponent } from './energy-section/energy-section.component';
import { EnvironmentSectionComponent } from './environment-section/environment-section.component';
import { FiltersSectionComponent } from './filters-section/filters-section.component';
import { RevenueSectionComponent } from './revenue-section/revenue-section.component';
import { TransactionsSectionComponent } from './transactions-section/transactions-section.component';

export const StatisticsView = (): React.JSX.Element => {
  // USER PERMISSIONS //////////////////////////////////////////////////////////

  const userPermissions = useAppSelector(permissions);

  const hasAccessToTransaction = useMemo(
    () =>
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.STATISTICS_SESSIONS_INFO,
        action: ActionsByResource.STATISTICS_SESSIONS_INFO.READ,
      }),
    [userPermissions],
  );

  const hasAccessToEnergy = useMemo(
    () =>
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.STATISTICS_ENERGY,
        action: ActionsByResource.STATISTICS_ENERGY.READ,
      }),
    [userPermissions],
  );

  const hasAccessToRevenue = useMemo(
    () =>
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.STATISTICS_REVENUE,
        action: ActionsByResource.STATISTICS_REVENUE.READ,
      }),
    [userPermissions],
  );

  const hasAccessToChannels = useMemo(
    () =>
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.STATISTICS_CHANNELS,
        action: ActionsByResource.STATISTICS_CHANNELS.READ,
      }),
    [userPermissions],
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.XL}>
      <Stack direction="column" flex={1} gap={GapEnum.M}>
        <FiltersSectionComponent />
        <Divider />
        {hasAccessToTransaction && (
          <>
            <TransactionsSectionComponent />
            <Divider />
          </>
        )}
        {hasAccessToEnergy && (
          <>
            <EnergySectionComponent />
            <Divider />
          </>
        )}
        {hasAccessToRevenue && (
          <>
            <RevenueSectionComponent />
            <Divider />
          </>
        )}
        {hasAccessToChannels && (
          <>
            <ChargePointSectionComponent />
            <Divider />
          </>
        )}
        {hasAccessToEnergy && <EnvironmentSectionComponent />}
      </Stack>
    </Stack>
  );
};
